/**
 * @param condition - 条件式（例: isMobile など）
 * @param trueValue - 条件が true の場合に返す値
 * @param falseValue - 条件が false の場合に返す値
 * @returns - 条件を満たす場合は trueValue を、そうでない場合は falseValue を返す
 */
export const responsiveValue = <T>(condition: boolean, trueValue: T, falseValue: T): T => {
  return condition ? trueValue : falseValue
}
